<template>
  <div class="skin">
    <div class="skin_title">
      <div>
      <img src="../../assets/img/leftnav/zthf.png" alt="" @click="displayleft">
      <div>主题换肤</div>
      </div>
    </div>
    <div class="skin_content">
      <ul>
        <li
          v-for="(item, index) in bgc"
          :key="index"
          :style="`backgroundColor: ${item}`"
          :class="currentItem == index ? 'highlight' : ''"
          @click="currentClick(index, `${item}`)"
        >
          <p :style="`border: 4px solid ${bder[index]}`"></p>
          <span v-if="currentItem == index">默认</span>
        </li>
      </ul>
    </div>
     <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
</template>

<script>
import leftNav from "../../components/content/leftNav";
export default {
   components: {
    leftNav,
  },
  data() {
    return {
      bgc: [
        "#f2f4f8",
        "#dfedf9",
        "#f2e7f9",
        "#ffe4e9",
        "#d5f1e5",
        "#e7ecf0",
        "#f89661",
        "#159bf4",
        "#00c9ca",
        "#ff7699",
        "#0ac7f0",
      ],
      bder: ["#7e8aa2", "#1e598c", "#7d5294", "#ac395d", "#1e704d", "#586570"],
      currentItem: 0,
      drawer: false,
    };
  },
  created() {
    this.currentItem = localStorage.getItem("bgcnum");
    console.log(this.currentItem);
  },
  mounted() {},
  methods: {
     //左边显示
    displayleft() {
      if(document.body.clientWidth <= 1200){
        this.drawer = true;
      }
    },
    currentClick(index, colo) {
      console.log(index, colo);
      this.currentItem = index;
      localStorage.setItem("bgcol", colo);
      let bgcolor = localStorage.getItem("bgcol");
      localStorage.setItem("themeClor",colo)

      
      localStorage.setItem("bgcnum", index);
      let root = document.querySelector(":root");
      root.style.setProperty("--color-theme", bgcolor);
    },
  },
};
</script>

<style lang="scss" scoped>
.skin {
  width: 100%;
  height: 100%;
  padding: 0 2%;
  background-color: var(--color-theme);
  .skin_title {
    font-size: 25px;
    color: #333333;
    padding-top: 50px;
    margin-bottom: 42px;
    div {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
        margin-right: 20px;
      }
    }
  }

  .skin_content {
    width: 100%;
    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      li {
        margin-right: 34px;
        margin-bottom: 30px;
        width: 13%;
        height: 210px;
        background-color: #f89661;
        border-radius: 10px;
        position: relative;
        span {
          position: absolute;
          bottom: 15px;
          right: 18px;
          color: #999999;
          font-size: 15px;
          background-color: #c2c3c7;
          width: 56px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          border-radius: 12px;
        }
        p {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
      .highlight {
        p {
          border: none !important;
        }
        box-shadow: 0px 4px 15px 1px rgba(0, 0, 0, 0.06);
        border: solid 4px #02d5b1;
        text-align: center;
      }
    }
  }
}
</style>